export default "__VITE_ASSET__CftZGb$h__"